import { ModuleWithProviders, NgModule } from '@angular/core';
import { OverlayContainer, ScrollDispatcher, ScrollStrategyOptions } from '@angular/cdk/overlay';

import { ElOverlayContainer } from '../overlay/mapping';
import { ElOverlayContainerAdapter } from './overlay-container-adapter';
import { ElScrollDispatcherAdapter } from './scroll-dispatcher-adapter';
import { ElViewportRulerAdapter } from './viewport-ruler-adapter';
import { ElBlockScrollStrategyAdapter, ElScrollStrategyOptions } from './block-scroll-strategy-adapter';


@NgModule({})
export class ElCdkAdapterModule {
  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: ElCdkAdapterModule,
      providers: [
        ElViewportRulerAdapter,
        ElOverlayContainerAdapter,
        ElBlockScrollStrategyAdapter,
        { provide: OverlayContainer, useExisting: ElOverlayContainerAdapter },
        { provide: ElOverlayContainer, useExisting: ElOverlayContainerAdapter },
        { provide: ScrollDispatcher, useClass: ElScrollDispatcherAdapter },
        { provide: ScrollStrategyOptions, useClass: ElScrollStrategyOptions },
      ],
    };
  }
}
